import PlaceSelector from './src/main';

/* istanbul ignore next */
PlaceSelector.install = function(Vue) {
  Vue.component(PlaceSelector.name, PlaceSelector);
};

export default PlaceSelector;
